import Context from './components/Context';
export * from './icons';
export * from './other';
export * from './components/twoTonePrimaryColor';
export { default as createFromIconfontCN } from './components/IconFont';
export { default } from './components/Icon';
var IconProvider = Context.Provider;
export { IconProvider };
